import { sendGoogleEvent } from '@html/_common/utils';

export default function initiateAskQuestion({
  tourName,
  tourId,
  operatorName,
  onAskQuestionSuccess,
}) {
  const tour = {
    name: tourName,
    id: tourId,
    operatorName,
    forceEnqiry: true,
  };

  const askButtonsSelector = '.gfq, .js-ao-tour-sticky-bar__cta--question,  .js-ao-tour-ask-expert-cta-banner__button, .js-ao-tour-bottom-banner__cta-ask, .js-ao-tour-start-planning-your-tour__cta-ask';
  $('main').on('click', askButtonsSelector, (e) => {
    const $clickedElement = $(e.currentTarget);

    tour.type = $clickedElement.hasClass('fq') ? 'river-cruise' : false;

    if ($clickedElement.data('date')) {
      tour.date = $clickedElement.data('date');
    }

    e.preventDefault();

    let actionLabel = 'Ask a question open';
    if (tour.type === 'river-cruise') {
      actionLabel += ' - Cruise Quote';
    }

    const clickSource = $clickedElement.hasClass('js-ao-tour-sticky-bar__cta--question') ? 'cta_bar' : 'body';

    sendGoogleEvent('Ask A Question', actionLabel, tourName, {
      ampEventName: 'ask_question_form_opened',
      tourID: tour.id,
      operator_name: tour.operatorName,
      ask_question_type: 'tour',
      click_source: clickSource,
    });

    import(/* webpackChunkName: "AskAQuestion" */'@html/_common/question/script').then((module) => {
      const AskAQuestion = module.default;
      const question = new AskAQuestion();
      question.terminate();
      question.startEnquiryDialog(
        tour,
        null,
        onAskQuestionSuccess,
      );
    });

    $(e.target).blur();

    return false;
  });
}
